import { render, staticRenderFns } from "./OrderHistoryTabRequester.vue?vue&type=template&id=34aa39b0&"
import script from "./OrderHistoryTabRequester.vue?vue&type=script&lang=js&"
export * from "./OrderHistoryTabRequester.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports